






import { Vue, Component, Prop } from 'vue-property-decorator';
import { EStatusType } from './types/status-type';

@Component({
  name: 'BaseStatusBadge',
})
export default class BaseStatusBadge extends Vue {
  @Prop() statusType: EStatusType;
  @Prop() text: string;
}
